export default {
  oops: 'Hoppsan!',
  validOrigin: 'Välj en giltig avreseplacering',
  validDestination: 'Välj en giltig destination',
  validOutboundDate: 'Vänligen välj ett giltigt avresedatum',
  validReturnDate: 'Var god välj ett giltigt returdatum',
  validChildAges: 'Ange ålder för alla barn.',
  oneChild: 'Endast ett barn (i åldern 0–2) per vuxen tillåts',
}
